import React from 'react';
import Sidebar from './Sidebar';
import NotificationBell from './NotificationBell';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar />
      <div className="pl-64">
        {/* Topbar */}
        <div className="h-16 bg-white border-b border-slate-200 sticky top-0 z-40 px-8 flex items-center justify-end gap-4">
          <NotificationBell />
        </div>
        <main className="p-8">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
